module.exports = __webpack_public_path__ + "img/banner3_4.0183e296.png";